<template>
  <div
    class="tw-w-full tw-relative tw-font-inter"
    @mousedown.stop="handleClickOutside"
  >
    <div class="tw-relative tw-flex tw-items-center">
      <i class="fas fa-search tw-absolute tw-left-3 tw-text-gray-400" />
      <input
        v-model="searchQuery"
        type="text"
        :disabled="!isActive"
        :placeholder="placeholder"
        class="tw-rounded-lg tw-p-2 tw-pl-10 tw-w-full focus:tw-outline-none tw-bg-[#F6F7F8] tw-text-base tw-border tw-border-solid tw-border-[#DFE2E7] disabled:tw-opacity-40 disabled:tw-text-[#79849A]"
        @input="onSearch"
        @focus="showDropdown = true"
        @blur="showDropdown = false"
      >
    </div>
    <ul
      v-if="showDropdown"
      class="tw-max-h-52 tw-overflow-y-auto tw-absolute tw-z-10 tw-inset-x-0 tw-bg-[#F6F7F8] tw-rounded-lg tw-mt-1 tw-shadow-lg"
    >
      <li
        v-for="item in valueSets"
        :key="item.id"
        class="tw-text-black tw-p-2 tw-cursor-pointer hover:tw-bg-gray-300"
        @mousedown.stop="selectItem(item)"
      >
        {{ item.name }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: 'Search...',
    },
    valueSets: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      searchQuery: '',
      showDropdown: false,
    };
  },
  methods: {
    onSearch() {
      this.$emit('search', this.searchQuery);
      this.showDropdown = this.valueSets.length > 0;
    },
    selectItem(item) {
      console.log('CALLING SELECT', item);
      this.searchQuery = item.name; // Update searchQuery with selected item's name
      this.$nextTick(() => {
        this.showDropdown = false;
      });
      this.$emit('select', item);
    },
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.showDropdown = false;
      }
    },
  },
};
</script>

<style scoped>
</style>
